import is from 'is_js';

export const DefaultAttendanceStatus = 'unmarked';

export const AttendanceStatus = {
  present: 'present',
  absent: 'absent',
  late: 'late',
  unmarked: 'unmarked',
  notapplicable: 'notapplicable',
};

export const AttendanceStatusDisplayName = {
  [AttendanceStatus.present]: 'Present',
  [AttendanceStatus.absent]: 'Absent',
  [AttendanceStatus.late]: 'Late',
  [AttendanceStatus.unmarked]: 'Unmarked',
  [AttendanceStatus.notapplicable]: 'Not Applicable',
};

export const AttendanceStatusBackendNames = {
  present: AttendanceStatus.present,
  absent: AttendanceStatus.absent,
  late: AttendanceStatus.late,
  unmarked: AttendanceStatus.unmarked,
  notapplicable: AttendanceStatus.notapplicable,
};

export const AttendanceStatusColorMappings = {
  [AttendanceStatus.present]: 'green',
  [AttendanceStatus.absent]: 'red',
  [AttendanceStatus.late]: 'amber',
};

export function getDisplayName(attendanceStatus) {
  return AttendanceStatusDisplayName[attendanceStatus];
}

export function convertBackendAttendanceStatusToAttendanceStatus(
    backendAttendanceStatus, isMarking) {
  const backendAttendanceStatusLower =
    is.string(backendAttendanceStatus) ? backendAttendanceStatus.toLowerCase() : null;
  if (isMarking &&
      (! backendAttendanceStatus || AttendanceStatusBackendNames[backendAttendanceStatusLower] ===
          AttendanceStatus.unmarked)) {
    return AttendanceStatus.present;
  }
  return AttendanceStatusBackendNames[backendAttendanceStatusLower] || AttendanceStatus.unmarked;
}

export function validateAttendanceStatus(status) {
  if (AttendanceStatus[status]) {
    return true;
  }
  throw new Error(`Status "${status}" is not valid! Use the Status object provided`);
}



// WEBPACK FOOTER //
// ./data/SessionsAttendance/status.js